var map = {
	"./check.svg": 4,
	"./close.svg": 5,
	"./envelope.svg": 6,
	"./facebook.svg": 7,
	"./info.svg": 8,
	"./instagram.svg": 9,
	"./linkedin.svg": 10,
	"./mail.svg": 11,
	"./mobile.svg": 12,
	"./paperplane.svg": 13,
	"./pause.svg": 14,
	"./phone.svg": 15,
	"./play.svg": 16,
	"./prev.svg": 17,
	"./quote.svg": 18,
	"./search.svg": 19,
	"./sound-off.svg": 20,
	"./sound-on.svg": 21,
	"./table-check.svg": 22,
	"./table-cross.svg": 23,
	"./twitter.svg": 24,
	"./vimeo.svg": 25,
	"./xing.svg": 26,
	"./youtube.svg": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;